<el-main class="main">
  <div class="form">
    <div class="module module-header">
      <h1 class="header-form">Отправить заявку</h1>
    </div>
    <div class="module" label-position="top">
      <div class="moduleWrapper">
        <router-link class="module_link" to="/">
          <div class="module-item">
            <div class="module-item_main_content">
              <div>
                <img src="@/assets/cargo-send.png" alt="" />
              </div>

              <div class="module-item__text">
                <h3>заявка на забор груза</h3>
              </div>
            </div>

            <h2>Создать</h2>
          </div>
        </router-link>
        <router-link class="module_link" to="/forwardin-receipt">
          <div class="module-item">
            <div class="module-item_main_content">
              <div>
                <img src="@/assets/cargo-send.png" alt="" />
              </div>
              <div class="module-item__text">
                <h3>экспедиторская расписка</h3>
              </div>
            </div>
            <h2>Создать</h2>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</el-main>
